import { getAnalytics, logEvent, setUserProperties } from 'firebase/analytics'

export default function () {
  const { $firebaseApp, ssrContext } = useNuxtApp()

  let analytics
  if (!ssrContext) {
    analytics = getAnalytics($firebaseApp)
  } else {
    analytics = () => {
      // Analytics wont work SSR

    }
  }

  return {
    // Log an analytics event
    logAnalyticsEvent: ({ event, parameters }) => {
      if (ssrContext) { return }
      try {
        logEvent(analytics, event, parameters)
      } catch (error) {
        console.error(`Error logging analytics event: ${error}`)
      }
    },
    // Log an analytics event
    setUserProperties: (properties) => {
      if (ssrContext) { return }
      try {
        setUserProperties(analytics, properties)
      } catch (error) {
        console.error(`Error setting analytics user properties: ${error}`)
      }
    }

  }
}
